import { render, staticRenderFns } from "./ShowroomFootfall.vue?vue&type=template&id=239fa310&"
import script from "./ShowroomFootfall.vue?vue&type=script&lang=js&"
export * from "./ShowroomFootfall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports